import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'

export const instituicaoEncaminhamentoService = {

    getAll: () => {
        return api.get(`${OperacoesWebAPI.InstituicaoEncaminhamento}/`,)
            .then((res) => res)
            .catch(err => err)
    },

    getComFiltros: (descricao: string = "") => {
        return api.get(`${OperacoesWebAPI.InstituicaoEncaminhamento}/getcomfiltros`, { params: { descricao } })
            .then((res) => res)
            .catch(err => err)
    },

    post: (instituicaoEncaminhamento: any) => {
        return api.post(`${OperacoesWebAPI.InstituicaoEncaminhamento}`, instituicaoEncaminhamento)
    },

    put: (instituicaoEncaminhamento: any) => {
        return api.put(`${OperacoesWebAPI.InstituicaoEncaminhamento}`, instituicaoEncaminhamento)
    },

    delete: (instituicaoEncaminhamentoID: number) => {
        return api.delete(`${OperacoesWebAPI.InstituicaoEncaminhamento}?id=${instituicaoEncaminhamentoID}`)
    }
}